import script from "./UQuillEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./UQuillEditor.vue?vue&type=script&setup=true&lang=js"

import "./UQuillEditor.vue?vue&type=style&index=0&id=49c9f5d1&lang=scss"
import "./UQuillEditor.vue?vue&type=style&index=1&id=49c9f5d1&lang=css"

const __exports__ = script;

export default __exports__